/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mascot_Chat_Ph_HandoffInputs */

const tr_mascot_chat_ph_handoff = /** @type {(inputs: Mascot_Chat_Ph_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesajını yaz, ekibe iletelim…`)
};

const en_mascot_chat_ph_handoff = /** @type {(inputs: Mascot_Chat_Ph_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type your message, and we'll forward it to the team…`)
};

const de_mascot_chat_ph_handoff = /** @type {(inputs: Mascot_Chat_Ph_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schreib deine Nachricht, wir leiten sie an das Team weiter…`)
};

const ru_mascot_chat_ph_handoff = /** @type {(inputs: Mascot_Chat_Ph_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Напишите сообщение, и мы передадим его команде…`)
};

/**
* | output |
* | --- |
* | "Type your message, and we'll forward it to the team…" |
*
* @param {Mascot_Chat_Ph_HandoffInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mascot_chat_ph_handoff = /** @type {((inputs?: Mascot_Chat_Ph_HandoffInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mascot_Chat_Ph_HandoffInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mascot_chat_ph_handoff(inputs)
	if (locale === "de") return de_mascot_chat_ph_handoff(inputs)
	if (locale === "ru") return ru_mascot_chat_ph_handoff(inputs)
	return tr_mascot_chat_ph_handoff(inputs)
});